/* eslint-disable global-require */
/* eslint-disable import/no-extraneous-dependencies */
if (module.hot || process.env.NODE_ENV !== 'production') {
  module.exports = {
    // The red box (aka red screen of death) component to display your errors
    // https://github.com/commissure/redbox-react
    ErrorReporter: require('redbox-react').default,
  };
}
